<template lang="pug">
div
  slot(name="reasontype")
    span.floatr.advice-tip 采纳以下
        i.red  {{adviceSuggestNum}}
        |  个建议预计展现量提升
        i.red  {{adviceEstiAddAdpv}}
        | ，点击量提升
        i.red  {{adviceEstiAddAdclick}}
  .advice-table
    HeadFixedTable(
      :columns = "currentColumns",
      :checkbox="hasCheckbox",
      :check_all="hasCheckbox",
      :checkbox_length="1000",
      :isAllChecked= "isAllChecked",
      :hasPagination = "true",
      @pageChange = "pageChange",
      :list = "currentList"
      )
      v-tooltip(
        slot="adjust_quota",
        :tip="'建议预算是通过流量预估给出的建议，若修改不得低于当前预算，否则达不到优化效果'",
        pos="left")
        i.fa.fa-question-circle(style="margin-left: 5px;")

      template(slot="adjust_quota-td" scope="props")
        span(v-show="!props.item.priceEdit") {{props.item.submit_quota}}
        span(
          @click.stop="stop",
          v-show="props.item.priceEdit",
          style="position: relative"
          )
          input.size-small(type="text",
            :placeholder="'最多保留两位小数'",
            :class="{'error': isQuotaUnvalid(props.item)}"
            v-model="props.item.submit_quota",
            @keyup.enter="saveQuota(props.item)"
          )
          span.warning-tip(v-show="props.item.quotaErrorShow && quotaUnvalidMsg != ''") {{quotaUnvalidMsg}}
            i.fa.fa-times(@click.stop="props.item.quotaErrorShow = false")
        span.btn.btn-icon(@click.stop="openQuota(props.item)" v-show="isEditable && !props.item.status")
          i.fa.fa-edit

      template(slot="delete-td" scope="props")
          slot(name="delete", :item="props.item")
      template(slot="status-td" scope="props")
          slot(name="status", :item="props.item")

</template>
<script>
import HeadFixedTable from '../../component/fold-table.vue'
import Mixin from '../mixin.js'

export default {
  mixins: [Mixin],
  props: {
    extendColumns: {
      type: Array,
      default() {
        return  []
      }
    },
    bgtype: {
      type: String,
      default: 'plan'
    },
    isAllChecked: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    hasCheckbox: {
      type: Boolean,
      default: true
    },
    list: {
      type: [Array, Object],
      default() {
        return [{
          "org_quota": 100,
          "adjust_quota": 200,
          "reason": 1,
          "reasonDesc": "ceshi",
          "plan": 'test',
          "recent7day_offlines": 10,
          "adcpc": 10,
          "loss_impr": 10,
          "anum": 10,
        }]
      }
    }
  },
  data() {
    return {
      quotaUnvalidMsg : ''
    }
  },
  components: {
      HeadFixedTable,
  },
  computed: {
    maxQuota() {
      return this.bgtype == 'plan' ? 10000000 : 990000
    },
    //勾选建议数量
    adviceSuggestNum() {
      return this.$store.state.tableCheckList.length
    },
    adviceEstiAddAdpv() {
      let result = 0
      _.map(this.$store.state.tableCheckList, (item) => {
        result += +item.esti_add_adpv
      })
      return result
    },
    adviceEstiAddAdclick() {
      let result = 0
      _.map(this.$store.state.tableCheckList, (item) => {
        result += +item.esti_add_adclick
      })
      return result
    },

    currentColumns() {
      const titles = {
        plan: '推广计划',
        custname: '账户名称'
      }
      let list = [{
        title: titles[this.bgtype],
        key: this.bgtype 
      },{
        title: "过去七天撞线",
        key: "recent7day_offlines"
      },{
        title: "预估损失流量",
        key: "loss_impr"
      },{
        title: "当前预算(￥)",
        key: "org_quota",
        render(index, value, item) {
          return parseFloat(value, 10).toFixed(2)
        }
      },{
        title: "建议预算(￥)",
        key: "adjust_quota",
        render(index, value, item) {
          return ''
        }
      }]
      return _.concat(list, this.extendColumns)
    },
    currentList() {
      return _.map(_.cloneDeep(this.list), item => {
        this.$set(item, 'checked', false)
        this.$set(item, 'priceEdit', false)
        this.$set(item, 'quotaErrorShow', false)
        this.$set(item, 'adjust_quota', parseFloat(item.adjust_quota, 10).toFixed(2))
        !_.has(item, 'submit_quota') && this.$set(item, 'submit_quota', item.adjust_quota)
        return item
      })
    }
  },
  mounted() {
    document.addEventListener('click', this.closeEditPanel);
  },
  destroyed() {
      document.removeEventListener('click', this.closeEditPanel);
  },
  methods: {
    stop() {},
    isQuotaUnvalid(item) {
      if(!/^\d+(\.\d{0,2})?$/.test(item.submit_quota)) {
        this.quotaUnvalidMsg = `请输入有效数字，最多保留两位小数`
        return true
      }

      this.quotaUnvalidMsg = parseFloat(item.submit_quota,10) > this.maxQuota ? '预算不得超过'+ this.maxQuota :
                            parseFloat(item.submit_quota,10) < parseFloat(item.org_quota,10) ? '预算不得低于当前预算' : ''
      return parseFloat(item.submit_quota,10) < parseFloat(item.org_quota,10) || parseFloat(item.submit_quota,10) > this.maxQuota
    },
    pageChange(list) {
      this.$emit('pageChange', list)
    },
    openQuota(item) {
      if(item.priceEdit) return
      let editQuotaObj = _.find(this.currentList, item => item.priceEdit)
      if(_.isEmpty(editQuotaObj)) {
        this.pushItemIntoCheckList(item)
        this.$set(item, 'priceEdit', true)
      } else {
        this.saveQuota(editQuotaObj)
      }

    },
    closeEditPanel() {
      let editQuotaObj = _.find(this.currentList, item => item.priceEdit)
      !_.isEmpty(editQuotaObj) && this.saveQuota(editQuotaObj)
    },
    saveQuota(item) {
      if(this.isQuotaUnvalid(item)) {
        this.$set(item, 'quotaErrorShow', true)
        return
      } else {
        this.$set(item, 'quotaErrorShow', false)
      } 
      this.$set(item, 'submit_quota', parseFloat(item.submit_quota, 10).toFixed(2))
      this.pushItemIntoCheckList(item)
      this.$set(item, 'priceEdit', false)
    }
  }
}
</script>
<style scoped>
.fold-table .btn-icon{
  padding: 0 5px;
  vertical-align: baseline;
}
.advice-tip {
  margin-right: 20px;
  margin-top: 20px;
  line-height: 1em;
  margin-bottom: 20px;
}
.modal-bd-wrapper .modal-table-wrapper .advice-table{
    border: 1px solid #DADFE6;
    border-top: none;
}
</style>



// WEBPACK FOOTER //
// budget_advice_table.vue?145930ab